import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {
  RolActividadCheckElement,
  NuevoVinculoFormInput,
  Rol,
  Tipo_Persona,
  ActividadCheckElement,
  ActividadConNombre
} from '../entity-roles/roles.model';

import { MatStepper } from '@angular/material/stepper';
import {
  DocumentoPersonaFormInput,
  createEmptyDocumentoPersonaFormInput
} from '../../persona/documentos-persona/documentos-persona.model';
import { RPERolActividades } from '../rpe-rol-actividades/rpe-rol-actividades.model';
import { DocumentoPersonaFormComponent } from '../../persona/documentos-persona/documento-persona-form/documento-persona-form.component';
import {
  EntidadProductivaYActividades,
  EntidadesProductivaActividadService
} from '@rpe/registro-personas-empresas-lib';

@Component({
  selector: 'rpe-nuevo-vinculo-form',
  templateUrl: './nuevo-vinculo-form.component.html',
  styleUrls: ['./nuevo-vinculo-form.component.scss']
})
export class NuevoVinculoFormComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') stepper: MatStepper;

  @Input()
  set formInput(nuevoVinculoFormInput: NuevoVinculoFormInput) {
    this._formInput = nuevoVinculoFormInput;
  }
  get formInput(): NuevoVinculoFormInput {
    return this._formInput;
  }

  _formInput: NuevoVinculoFormInput = null;
  documentoPersonaFormInput: DocumentoPersonaFormInput =
    createEmptyDocumentoPersonaFormInput();

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<RPERolActividades>();
  @Output() formSubmit = new EventEmitter<RPERolActividades>();

  @ViewChild(DocumentoPersonaFormComponent, { static: true })
  documentoPersonaForm: DocumentoPersonaFormComponent;

  // @ViewChild('documentoPersonaRPE', { static: false }) set content(content: DocumentoPersonaFormComponent) {
  //   console.log("Entro ViewChild ",content);
  //   //this.documentoPersonaForm = content;
  //   if(content) { //inicialmente indefinido
  //     this.documentoPersonaForm = content;
  //     this.nuevoVinculoFormGroup
  //       .get('documentos')
  //       .setValidators(this.documentoPersonaForm.createGroup);
  //   }
  // }

  nuevoVinculoFormGroup: FormGroup = null;
  actividadesCheck: ActividadCheckElement[] = [];
  checkedList: boolean[] = [];
  sinActividades = true;
  validStatus = 'INVALID';
  stepEmpresa = false;
  existeEmpresa = true;
  empresaActividades: EntidadProductivaYActividades;
  hoy = new Date();

  constructor(
    private fb: FormBuilder,
    private entidadesProductivaActividadService: EntidadesProductivaActividadService,
    private ref: ChangeDetectorRef
  ) {}

  documentoValidator(control: FormGroup): { [s: string]: boolean } {
    if (control.value) {
      return { invalidDate: true };
    }

    return null;
  }

  // documentoCondicionalValidator(formGroup: FormGroup): any {
  //   console.log('documentoCondicionalValidator');
  //   if (
  //     formGroup.value &&
  //     formGroup.get('tipo_persona').value === 'persona_fisica' &&
  //     this &&
  //     this.documentoPersonaForm != undefined
  //   ) {
  //     return   this.documentoPersonaForm.createGroup();
  //   }
  //   return null;
  // }

  ngOnInit(): void {
    this.nuevoVinculoFormGroup = this.fb.group(
      {
        rut: ['', [Validators.required]],
        tipo_rol: ['', [Validators.required]],
        tipo_persona: ['', [Validators.required]],
        documentos_persona: this.fb.array([
          this.fb.group([this.documentoPersonaForm.createGroup()])
        ])
      }
      // },
      // {
      //   validators: [this.documentoCondicionalValidator]
      // }
    );

    // si se cambia el valor inicial de tipo persona modificar ambas cosas
    this.nuevoVinculoFormGroup.get('tipo_persona').setValue('persona_juridica');
    this.nuevoVinculoFormGroup.get('documentos_persona').disable();

    this.nuevoVinculoFormGroup.valueChanges.subscribe((_) => {
      // tengo que armar el rol y la lista de actividades_id
      const rol: Rol = {
        id: null,
        persona_id: 5, // hardcodeado, obtener despues el usuario logueado
        entidad_productiva_id: this.empresaActividades
          ? this.empresaActividades.entidad_productiva_id
          : null,
        acreditacion_representacion: null,
        es_creador: false,
        fecha_alta: this.hoy,
        fecha_baja: null,
        vinculo_aprobado_rol: true,
        vinculo_aprobado_entidad_productiva: false,
        eliminado: false,
        tipo_rol_id: this.nuevoVinculoFormGroup.get('tipo_rol').value, // TipoRol,
        laboratorios_id: null
      };
      // dependiendo del rol elegido selecciono las actividades
      let actividades_id: number[] = [];
      if (this.nuevoVinculoFormGroup.get('tipo_rol').value === 6) {
        // tra
        actividades_id = this.formInput.actividad_con_nombre
          .filter((a) => a.tipoActividad === 10)
          .map((a) => a.actividad);
      }
      if (this.nuevoVinculoFormGroup.get('tipo_rol').value === 5) {
        // tr
        actividades_id = this.actividadesCheck
          .filter((a) => a.value == true)
          .map((a) => a.actividadConNombre.actividad);
      }
      const rpeRolActividades: RPERolActividades = {
        rol: rol,
        actividades_id: actividades_id
      };

      this.formValueChanges.emit({
        ...rpeRolActividades
      });
    });

    this.nuevoVinculoFormGroup.statusChanges.subscribe((f) => {
      this.validStatus = f;
      this.validarStatus();
    });
    this.comprobarSinActividad();
  }

  ngAfterViewInit() {
    this.stepper._getIndicatorType = () => 'number';
  }

  // formStatusChanges(status: string) {
  //   this.formValid = status === 'VALID';
  // }
  //
  // formValueChanges(rol: Rol) {
  //
  // }

  // validstatus es el que se obtiene del formulario, este método valida los check
  validarStatus() {
    let salida: string = this.validStatus;
    if (salida == 'VALID') {
      // si es tr tiene que tener al menos una actividad
      if (
        this.nuevoVinculoFormGroup.get('tipo_rol').value == 5 &&
        this.sinActividades
      ) {
        salida = 'INVALID';
      }
    }
    this.formStatusChanges.emit(salida);
  }

  onCheckChange(event: any, indice: number) {
    this.checkedList[indice] = event.currentTarget.checked;
    this.comprobarSinActividad();
    this.actividadesCheck[indice].value = event.currentTarget.checked;
    // se fuerza la disparada del evento con el valor guardado de status
    this.validarStatus();
  }

  handleChangeTipoPersona(event: any) {
    // se deshabilitan las validaciones; cada tipo de persona se encarga de habilitar y deshabilitar
    if (
      this.nuevoVinculoFormGroup.get('tipo_persona').value == 'persona_juridica'
    ) {
      this.nuevoVinculoFormGroup.get('rut').enable();
    } else {
      this.nuevoVinculoFormGroup.get('rut').disable();
      // se borran los campos
      this.nuevoVinculoFormGroup.get('rut').setValue(null);
      this.checkedList = [];
      this.actividadesCheck = [];
    }

    if (
      this.nuevoVinculoFormGroup.get('tipo_persona').value == 'persona_fisica'
    ) {
      this.nuevoVinculoFormGroup.get('documentos_persona').enable();
    } else {
      this.nuevoVinculoFormGroup.get('documentos_persona').disable();
      // se borran los campos
      this.documentoPersonaForm.limpiarCampos();
      this.checkedList = [];
      this.actividadesCheck = [];
    }
  }

  onSiguienteStepEmpresa() {
    // Si tengo ingresado el rut o el documento de la persona fisica compruebo a la empresa
    if (
      (this.nuevoVinculoFormGroup.get('tipo_persona').value ==
        'persona_juridica' &&
        this.nuevoVinculoFormGroup.get('rut').value != null &&
        this.nuevoVinculoFormGroup.get('rut').value != '') ||
      (this.nuevoVinculoFormGroup.get('tipo_persona').value ==
        'persona_fisica' &&
        this.nuevoVinculoFormGroup.get('documentos_persona.0.0').get('numero')
          .value != null &&
        this.nuevoVinculoFormGroup
          .get('documentos_persona.0.0')
          .get('pais_codigo').value != null &&
        this.nuevoVinculoFormGroup
          .get('documentos_persona.0.0')
          .get('tipo_documento_codigo').value != null)
    ) {
      // PF
      if (
        this.nuevoVinculoFormGroup.get('tipo_persona').value ==
        'persona_juridica'
      ) {
        this.entidadesProductivaActividadService
          .getEntidadesProductivaActividad(
            this.nuevoVinculoFormGroup.get('rut').value
          )
          .subscribe((ePA) => {
            // llama a servicio para obtener las actividades de la empresa con cierto rut
            // se obtienen los nombres de las actividades
            this.empresaActividades = ePA;
            this.existeEmpresa =
              this.empresaActividades.entidad_productiva_id != null;
            if (this.empresaActividades.entidad_productiva_id != null) {
              // console.log(this.empresaActividades.entidad_productiva_id);
              this.stepper.next();
              this.agregarActividades(ePA);
            }
            this.ref.detectChanges();
          });
      } else {
        this.entidadesProductivaActividadService
          .getEntidadesProductivaActividad(
            undefined,
            this.nuevoVinculoFormGroup
              .get('documentos_persona.0.0')
              .get('pais_codigo').value,
            this.nuevoVinculoFormGroup
              .get('documentos_persona.0.0')
              .get('tipo_documento_codigo').value,
            this.nuevoVinculoFormGroup
              .get('documentos_persona.0.0')
              .get('numero').value
          )
          .subscribe((ePA) => {
            // llama a servicio para obtener las actividades de la empresa con cierto rut
            // se obtienen los nombres de las actividades
            this.empresaActividades = ePA;
            this.existeEmpresa =
              this.empresaActividades.entidad_productiva_id != null;
            if (this.empresaActividades.entidad_productiva_id != null) {
              // console.log(this.empresaActividades.entidad_productiva_id);
              this.stepper.next();
              this.agregarActividades(ePA);
            }
            this.ref.detectChanges();
          });
      }
    } else {
      this.onShowErrors();
    }
  }

  onSubmit() {
    this.formSubmit.emit(this.nuevoVinculoFormGroup.value);
  }

  agregarActividades(ePA: EntidadProductivaYActividades) {
    // se agregan las actividades a la lista de actividades
    const actividadConNombre: ActividadConNombre[] = [];
    ePA.actividades.forEach((actividad) => {
      actividadConNombre.push({
        nombreActividad: this.formInput.tiposActividad.find(
          (tipoActividad) => tipoActividad.id == actividad.tipo_actividad_id
        ).nombre,
        actividad: actividad.id,
        tipoActividad: actividad.tipo_actividad_id
      });
    });
    this.formInput = {
      ...this.formInput,
      actividad_con_nombre: actividadConNombre
    };

    this.checkedList = [];
    this.actividadesCheck = [];

    this.formInput.actividad_con_nombre.forEach((actividad) => {
      this.actividadesCheck.push({
        value: true,
        actividadConNombre: actividad
      });
      this.checkedList.push(true);
    });
    this.comprobarSinActividad();
    this.validarStatus();
  }

  /* onComprobar() {
    //TODO hay que comunicar a la entity que se quiere comprobar ahi se encarga de cambiar el forminput
    this.entidadesProductivaActividadService
      .getEntidadesProductivaActividad(
        this.nuevoVinculoFormGroup.get('rut').value
      )
      .subscribe((ePA) => {
        //llama a servicio para obtener las actividades de la empresa con cierto rut
        //se obtienen los nombres de las actividades
        console.log(ePA, 'ePA');
      });

    // el validstatus refiere al formulario en sí sin contar con las actividades
    if (this.validStatus != 'VALID') {
      return;
    }

    this.formInput = {
      ...this.formInput,
      actividad_con_nombre: [
        {
          nombreActividad: `Criador`,
          actividad: undefined
        },
        {
          nombreActividad: `Semillero`,
          actividad: undefined
        },
        {
          nombreActividad: `Cowboy`,
          actividad: undefined
        }
      ]
    };

    this.checkedList = [];
    this.actividadesCheck = [];

    this.formInput.actividad_con_nombre.forEach((actividad) => {
      this.actividadesCheck.push({
        value: true,
        actividadConNombre: actividad
      });
      this.checkedList.push(true);
    });
    this.comprobarSinActividad();
    this.validarStatus();
  }*/

  deshabilitarCheckear(): boolean {
    const salida: boolean =
      this.nuevoVinculoFormGroup.get('tipo_rol').value == null ||
      this.nuevoVinculoFormGroup.get('tipo_rol').value !== 6;
    return salida;
  }

  comprobarSinActividad() {
    this.sinActividades = true;
    if (this.checkedList) {
      const auxHaySeleccion = this.checkedList.find((ace) => ace == true);
      if (auxHaySeleccion) {
        this.sinActividades = false;
      }
    }
  }

  onShowErrors(): void {
    this.nuevoVinculoFormGroup.markAllAsTouched();
  }
}
